/**
 * Hooks de usuarios (mejora D follow-up del changelog cliente).
 *
 * De momento solo exponemos búsqueda — la usa el picker del diálogo de
 * miembros de equipo para evitar pegar IDs a mano.
 */
import { useQuery } from "@tanstack/react-query";
import { fetchWithAuth } from "@/lib/api/client";
import type { components } from "@/lib/api/generated";

export type UserSummary = components["schemas"]["UserSummary"];

export function useUserSearch(query: string, options?: { limit?: number }) {
  const trimmed = query.trim();
  const enabled = trimmed.length >= 2;
  const limit = options?.limit ?? 20;
  return useQuery<UserSummary[], Error>({
    queryKey: ["users", "search", trimmed, limit],
    queryFn: () =>
      fetchWithAuth(
        `/api/v1/users/search?q=${encodeURIComponent(trimmed)}&limit=${limit}`
      ),
    enabled,
    staleTime: 30_000,
  });
}
